import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";


export const FetchAllRounds = () => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-listing-template-all-roundss-fetch'],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startup-rounds/list/rounds-listing`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data,'values new')
            return data?.data?.data != undefined ? data?.data?.data : []
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchViewStartupDetails = (id) => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-FetchStartupDetails-FetchStartupDetails-FetchStartupDetails-fetch-view-view', id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/startup-details-new/${id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            const savedData = data.data.data[0];
            // console.log(data.data.data[0], 'datatatatat')
            const savedValues = {
                // step 1
                first_name: savedData?.first_name ? String(savedData?.first_name) : '',
                last_name: savedData?.last_name ? String(savedData?.last_name) : '',
                mobile_number: savedData?.mobile_number ? String(savedData?.mobile_number) : '',
                phone_code: savedData?.phone_code ? String(savedData?.phone_code) : '91',
                country: savedData?.country ? savedData?.country : null,
                state: savedData?.state ? savedData?.state : null,
                city: savedData?.city ? savedData?.city : null,
                email: savedData?.email ? savedData?.email : null,
                linkedin_url: savedData?.linkedin_url ? String(savedData?.linkedin_url)?.startsWith('https://') ? String(savedData?.linkedin_url)?.slice(8) : String(savedData?.linkedin_url) : '',
                // step 2
                // startup_logo: ("http://192.168.55.19:3001/assets/project_image/startup/" + savedData?.logo_url) || null,
                // startup_logo: savedData?.logo_url ? (savedData?.bucket_path + savedData?.logo_url) : null,
                startup_logo: (savedData?.startup_logo_path),
                startup_name: savedData?.startup_name ? savedData?.startup_name : "",
                entity_name: savedData?.entity_name ? savedData?.entity_name : "",
                formation_date: savedData?.formation_date ? savedData?.formation_date : null,
                formatted_formation_date: savedData?.formatted_formation_date ? savedData?.formatted_formation_date : null,
                sector_info: savedData?.sector_info ? savedData?.sector_info : "",
                business_model_info: savedData?.business_model_info ? savedData?.business_model_info : "",
                raised_round: savedData?.raised_round ? savedData?.raised_round : null,
                stage_info: savedData?.stage_info ? savedData?.stage_info : "",
                category_info: savedData?.category_info ? savedData?.category_info : "",
                // sector_ids: savedData?.sector_ids ? savedData?.sector_ids : [],
                pitch_deck_path: savedData?.pitch_deck_path ? savedData?.pitch_deck_path : null,
                pitch_deck_thumbnail_path: savedData?.pitch_deck_thumbnail_path ? savedData?.pitch_deck_thumbnail_path : null,
                pitch_deck_url: savedData?.pitch_deck_url ? savedData?.pitch_deck_url : null,
                round_name: savedData?.round_name || "",
                round_type: savedData?.round_type || "",
                description: savedData?.description || '',
                elevator_pitch_path: savedData?.elevator_pitch_path ? savedData?.elevator_pitch_path : null,
                product_video_path: savedData?.product_video_path || null,
                problem_solving: savedData?.problem_solving || "",
                website_url: savedData?.website_url ? String(savedData?.website_url)?.startsWith('https://') ? String(savedData?.website_url)?.slice(8) : String(savedData?.website_url) : '',

                coFoundersArray:
                    savedData?.cofounder && savedData?.cofounder?.length > 0 ? savedData?.cofounder?.map(item => (
                        {
                            edit: true,
                            name: item?.name || '',
                            title: item?.title || '',
                            bio: item?.bio || '',
                            linkedin_url: item?.linkedin_url ? String(item?.linkedin_url) : '',
                            image: item?.cofounder_image_path ? item?.cofounder_image_path : null,
                            image_name: item?.cofounder_image ? item?.cofounder_image : null,
                        }
                    )) : [],
                referral_type: savedData?.referral_type || '',
                referral_name: savedData?.referral_name || '',
                founder: savedData?.founder && savedData?.founder?.length > 0 ? {
                    name: savedData?.founder[0]?.name || '',
                    bio: savedData?.founder[0]?.bio || '',
                    title: savedData?.founder[0]?.title || '',
                    linkedin_url: savedData?.founder[0]?.linkedin_url ? savedData?.founder[0]?.linkedin_url : '',
                    image: savedData?.founder[0]?.founder_image_path ? savedData?.founder[0]?.founder_image_path : null,
                    founder_image: savedData?.founder[0]?.founder_image_path ? savedData?.founder[0]?.founder_image_path : null
                } : null,
                step: savedData?.step || 1,
                _id: savedData?._id,
                document_base_url: savedData?.document_base_url,
                backrr_base_url: savedData?.backrr_base_url,
                round_id: savedData?.startup_rounds_info,
                raised_round: savedData?.raised_round,
                created_date: savedData?.created_date,
                onboarded_createdAt: savedData?.onboarded_createdAt,
                slug: savedData?.slug
            }
            return { data: savedValues, status: savedData?.success }
        },
        refetchOnWindowFocus: false,
        retryDelay: 0,
        cacheTime: 0,
        enabled: id != null && !!id,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchRoundViewDetails = (id) => {
    return useQuery(
        ['master-listing-template-round--view-details-using-id-fetch', id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/round-details-new/${id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data, 'values new')
            const savedData = data?.data?.data[0];
            const savedValues = {
                // step 0
                round_name: savedData?.round_name || "",
                round_type: savedData?.round_type || '',
                security_type: savedData?.security_type || "",
                // step 1
                round_highlights: savedData?.round_highlights || "",
                total_round_size: savedData?.total_round_size || "",
                round_valuation: savedData?.round_valuation | "",
                minimum_cheque_size: savedData?.minimum_cheque_size || "",
                received_termsheet: savedData?.received_termsheet || false,
                committed_funding_amount: savedData?.committed_funding_amount || "",
                currency_id: savedData?.currency_id || "",
                currency: savedData?.currency_info || "",
                // step 2
                investors: savedData?.investors || [{ name: "", email: "" }],
                // step 3
                fund_utilization_highlights: savedData?.fund_utilization_highlights || "",
                fund_allocation_percentages: savedData?.fund_allocation_percentages || [
                    { name: "", percentage: 0 },
                ],
                // step 4
                traction_highlights: savedData?.traction_highlights || "",
                key_metrics: savedData?.key_metrics || [
                    {
                        heading: "",
                        properties: [
                            { key: "", value: "" },
                            { key: "", value: "" },
                            { key: "", value: "" },
                        ],
                    },
                ],
                // step 5
                documents: savedData?.documents || [

                ],
                // step 6
                faqs: savedData?.faqs || [
                    {
                        question: "",
                        answer: "",
                    },
                ],
                // step 7
                exit_highlights: savedData?.exit_highlights || "",
                runway_left: savedData?.runway_left || 'select_runway_left',
                monthly_net_burn: savedData?.monthly_net_burn || "",
                round_start_date: savedData?.round_start_date || null,
                round_closing_date: savedData?.round_closing_date || null,
                round_status: savedData?.round_status || "",
                ...savedData
            }
            return savedValues
        },
        refetchOnWindowFocus: false,
        enabled: !!id,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

// export const FetchRoundDocuments = ({ round_id }) => {
//     // console.log(page.page,page.search,"page")
//     return useQuery(
//         ['master-listing-template-all-roundss-fetch', round_id],
//         () => {
//             return axios({
//                 method: 'get',
//                 url: `${process.env.REACT_APP_BASE_URL}/investors/round-documents/${round_id}`,
//                 headers: {
//                     'Authorization': `Bearer ${checkForAuthorization()}`
//                 },
//             })
//         }, {
//         // select: (data) => data,
//         select: (data) => {
//             // console.log(data,'values new')
//             return data?.data?.data != undefined ? data?.data?.data?.documents : null
//         },
//         refetchOnWindowFocus: false,
//         cacheTime: 0,
//         retry: (failureCount, error) => {
//             return RetryOnError(failureCount, error)
//         },
//         onError: (err) => {
//             return verifyToken(err)
//         },
//     })
// }

export const FetchRoundDocuments = () => {
    // console.log(page.page,page.search,"page")
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/round-documents`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
}

export const UpdateStartupStatus = ({ investor_id }) => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/startups_status/${investor_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
}

// export const FetchAllStartupsListing = () => {
//     const defaultPayload = {
//         status: "new",
//         page: 1,
//         limit: 20,
//         sort: -1,
//         name: "",
//     }
//     return useMutation(
//         ({
//             payload, investor_id, queryParams
//         }) => {
//             return axios({
//                 method: 'post',
//                 url: `${process.env.REACT_APP_BASE_URL}/investors/get-startup-list/${investor_id}`,
//                 headers: {
//                     'Authorization': `Bearer ${checkForAuthorization()}`
//                 },
//                 data: {
//                     ...defaultPayload,
//                     ...payload,
//                     ...queryParams
//                 }
//             })
//         }, {
//         retry: (failureCount, error) => {
//             return RetryOnError(failureCount, error)
//         },
//         onError: (err) => {
//             return verifyToken(err)
//         },
//     })
// }

export const FetchAllStartupsListing = () => {
    const defaultPayload = {
        // status: "new",
        page: 1,
        limit: 20,
        sort: -1,
        name: "",
    }
    return useMutation(
        ({
            payload, investor_id, queryParams
        }) => {
            const { status, value, ...rest } = payload;
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/get-startup-list/${investor_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
                data: {
                    ...defaultPayload,
                    ...rest,
                    ...queryParams
                }
            })
        }, {
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const InviteStartupPOST = () => {
    return useMutation(
        ({ payload, _id }) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/invite-startup/${_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const SaveFeedback = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/submit-feedback`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

// export const SaveInterest = () => {
//     return useMutation(
//         (payload) => {
//             return axios({
//                 method: 'post',
//                 url: `${process.env.REACT_APP_BASE_URL}/investors/show_interested`,
//                 headers: {
//                     Authorization: `Bearer ${checkForAuthorization()}`,
//                 },
//                 data: payload,
//             });
//         },
//         {
//             retry: 0,
//             // onSuccess: ()=>console.log("API successfull"),
//             retry: (failureCount, error) => {
//                 return RetryOnError(failureCount, error)
//             },
//             onError: (err) => {
//                 // console.error(err);
//                 return verifyToken(err);
//             }
//         }
//     );
// };

export const SaveInterest = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/show_interested`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const FetchInterestFeedbackStatus = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/get-investor-info`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};
export const SaveManageNotes = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/add-internal-notes`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const DeleteManageNotes = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'delete',
                url: `${process.env.REACT_APP_BASE_URL}/investors/delete-internal-notes`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload
            });
        },
        {
            retry: 0,
            // onSuccess: (data)=>console.log("API successfull"),
            // retry: (failureCount, error)=>{
            //   return RetryOnError(failureCount, error)
            // },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};

export const FetchManageNotes = ({ investor_id, startup_id }) => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-listing-template-all-managenotes-fetch', investor_id, startup_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/get-internal-notes/${investor_id}?startup_id=${startup_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data.data.data,'values new')
            return data?.data?.data != undefined ? data?.data?.data && data?.data?.data?.length > 0 ? data?.data?.data : [] : []
        },
        refetchOnWindowFocus: false,
        cacheTime: 0,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchAllStartupFeedbacks = ({ id: startup_id, value, page = 1, limit = 10, sort = -1 }) => {
    // console.log(id,"id")
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-listing-template-for-all-feedbacks-roundss-fffffff' + startup_id + value, startup_id, value, page, limit, sort],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/feedbacks/${startup_id}?page=${page}&limit=${limit}${sort != 0 ? `&sort=${sort}` : ''}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data,'values new')
            return { data: data?.data?.data, count: data?.data?.count || 0, limit: Number(data?.data?.limit) }
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchAllStartupFeedbacksByInvestorID = () => {
    return useMutation(
        ({ payload, params }) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/feedbacks/${params?.startup_id}?page=${params?.page}&limit=${params?.limit}${params?.sort != 0 ? `&sort=${params?.sort}` : ''}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const FetchFunding = ({ id: startup_id }) => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-listing-template-all-fundings-fetch' + startup_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/list/rounds-listing/${startup_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data.data.data,'values new')
            return { data: data?.data?.data }

        },
        refetchOnWindowFocus: false,
        cacheTime: 0,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchPipelineStatus = ({ id: startup_id, investor_id }) => {
    const enabled = Boolean(startup_id && investor_id);
    return useQuery(
        ['master-FetchPipelineStatus-template-FetchPipelineStatus-fundings-fetch', startup_id, investor_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/get-startup-status/${startup_id}?investor_id=${investor_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            return { 
                status: data?.data?.data?.status, 
                pipeline_id: data?.data?.data?.pipeline_id, 
                startup_round_id: data?.data?.data?.round_id && data?.data?.data?.round_id?.length > 0 ? data?.data?.data?.round_id[0] : null,
                investor_status_id:data?.data?.data?.investor_status_id
            }

        },
        refetchOnWindowFocus: false,
        enabled,
        cacheTime: 0,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const ChangePipelineInvestorStatus = () => {
    return useMutation(
        ({ payload, pipeline_id }) => {
            // console.log("Payload:", payload);
            // console.log("Startup ID:", pipeline_id);
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_BASE_URL}/investors/pipelineStartupStatus/${pipeline_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json'
                },
                data: payload
            })
        }, {
        // onSuccess: (data)=>console.log("API successfull"),
        // retry: (failureCount, error)=>{
        //   return RetryOnError(failureCount, error)
        // },
        retry: 0,
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchPipelines = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/dealFlow/get-pipelines/${payload?.investor_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                // data: payload,
            });
        },
        {
            retry: 0,
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};

export const FetchPipelinesStatuses = () => {
    return useMutation(
        ({ investor_id }) => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/dealFlow/get-pipeline-status/${investor_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        },
        {
            select: (data) => {
                return { data: data?.data?.data || [] }
            },
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                return verifyToken(err)
            }
        }
    );
}


// this updates the status in the pipeline for current startup
export const ChangeStatusForCurrentPipeline = () => {
    return useMutation(
        ({payload, pipeline_id}) => {
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_BASE_URL}/dealFlow/pipeline?pipeline_id=${pipeline_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json',
                },
                data: {...payload},
            });
        },
        {
            retry: 0,
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error);
            },
            onError: (err) => {
                return verifyToken(err);
            },
        }
    );
}


export const DeletePipelineStatus = ({ investor_id }) => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'delete',
                url: `${process.env.REACT_APP_BASE_URL}/dealFlow/delete-pipeline-status/${investor_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload
            });
        },
        {
            retry: 0,
            // onSuccess: (data)=>console.log("API successfull"),
            // retry: (failureCount, error)=>{
            //   return RetryOnError(failureCount, error)
            // },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};

export const ReorderStatuses = () => {
    return useMutation(
        ({payload, investor_id}) => {
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_BASE_URL}/dealFlow/update-display-order-status/${investor_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json',
                },
                data: payload,
            });
        },
        {
            retry: 0,
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error);
            },
            onError: (err) => {
                return verifyToken(err);
            },
        }
    );
}


export const ReorderPipelines = () => {
    return useMutation(
        ({payload, investor_id}) => {
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_BASE_URL}/dealFlow/update-display-order-pipeline/${investor_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json',
                },
                data: payload,
            });
        },
        {
            retry: 0,
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error);
            },
            onError: (err) => {
                return verifyToken(err);
            },
        }
    );
}

export const UploadPitchDeckBatch = ({ setProgress }) => {
    return useMutation(
        (formData) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/pitch-deck-import/batch`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'multipart/form-data',
                },
                data: formData,
                onUploadProgress: (data) => {
                    setProgress && setProgress(
                        Math.round((data.loaded / data.total) * 100) === 100
                            ? 99
                            : Math.round((data.loaded / data.total) * 100)
                    );
                },
            });
        },
        {
            retry: 0,
            onError: (err) => verifyToken(err),
        }
    );
};

export const NotifyBatchStartups = () => {
    return useMutation(
        ({ batch_id }) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/pitch-deck-import/batch/${batch_id}/notify`,
                headers: { Authorization: `Bearer ${checkForAuthorization()}` },
            });
        },
        {
            retry: 0,
            retry: (failureCount, error) => RetryOnError(failureCount, error),
            onError: (err) => verifyToken(err),
        }
    );
};

export const FetchBatchStatus = ({ batch_id, enabled }) => {
    return useQuery(
        ['pitch-deck-batch-status', batch_id],
        () => axios({
            method: 'get',
            url: `${process.env.REACT_APP_BASE_URL}/pitch-deck-import/batch/${batch_id}`,
            headers: { Authorization: `Bearer ${checkForAuthorization()}` },
        }),
        {
            enabled: !!batch_id && !!enabled,
            select: (data) => data?.data?.data,
            refetchInterval: (data) => {
                const status = data?.status;
                if (['completed', 'failed', 'partially_completed'].includes(status)) return false;
                return 3000;
            },
            refetchIntervalInBackground: true,
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
                // Stop retrying on 401 (auth error)
                if (error?.response?.status === 401) return false;
                // Keep retrying on network errors or server-down (no response) — up to 20 attempts
                // This prevents the query from entering error state and stopping the refetchInterval
                return failureCount < 20;
            },
            retryDelay: (failureCount) => Math.min(3000 * (failureCount + 1), 15000),
            onError: (err) => verifyToken(err),
        }
    );
};

export const FetchDealflowShortlistBatchStatus = ({ batch_id, enabled }) => {
    return useQuery(
        ['dealflow-shortlist-batch-status', batch_id],
        () => axios({
            method: 'get',
            url: `${process.env.REACT_APP_BASE_URL}/dealflow/ai-shortlist/batch/${batch_id}`,
            headers: { Authorization: `Bearer ${checkForAuthorization()}` },
        }),
        {
            enabled: !!batch_id && !!enabled,
            select: (data) => data?.data?.data,
            refetchInterval: (data) => {
                const status = data?.status;
                if (['completed', 'failed', 'partially_completed'].includes(status)) return false;
                return 2000;
            },
            refetchIntervalInBackground: true,
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
                if (error?.response?.status === 401) return false;
                return failureCount < 20;
            },
            retryDelay: (failureCount) => Math.min(3000 * (failureCount + 1), 15000),
            onError: (err) => verifyToken(err),
        }
    );
};

export const StartAIShortlistBatch = () => {
    return useMutation(
        (body) => axios({
            method: 'post',
            url: `${process.env.REACT_APP_BASE_URL}/dealflow/ai-shortlist/batch`,
            data: body,
            headers: { Authorization: `Bearer ${checkForAuthorization()}` },
        }),
        {
            retry: 0,
            onError: (err) => verifyToken(err),
        }
    );
};
export const SaveView = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/add-investor-view`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                },
                data: payload,
            });
        },
        {
            retry: 0,
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};
